import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function Poliurea() {
  return (
    <SpecializationPage
      testid="poliurea-page"
      quoteService="Impermeabilizzazione in poliurea"
      index="/ 03"
      title="Poliurea"
      lines={["Impermeabilizzazione", "in poliurea."]}
      subtitle="La tecnologia più avanzata per rendere impermeabile qualsiasi superficie: una membrana continua, elastica e senza giunti, applicata a spruzzo."
      image={IMG.waterproofing}
      accent="Impermeabile in pochi secondi, per sempre."
      intro={[
        "La poliurea è un rivestimento elastomerico bicomponente applicato a spruzzo ad alta pressione. Reagisce e polimerizza in pochi secondi, creando una membrana continua totalmente priva di giunti — il punto debole di ogni impermeabilizzazione tradizionale.",
        "Il risultato è una barriera impermeabile capace di seguire i movimenti della struttura, resistere ai raggi UV, agli sbalzi termici e all'aggressione chimica, con una durata nettamente superiore alle guaine bituminose.",
      ]}
      specs={[
        { k: "Tempo di indurimento", v: "3-5 sec" },
        { k: "Allungamento", v: "> 400%" },
        { k: "Spessore tipico", v: "2-3 mm" },
        { k: "Calpestabile", v: "1 ora" },
        { k: "Garanzia", v: "fino a 10 anni" },
        { k: "Giunti", v: "Zero" },
      ]}
      benefits={[
        { t: "Nessun giunto", d: "Membrana continua monolitica: elimina i punti critici dove l'acqua tradizionalmente s'infiltra." },
        { t: "Elasticità estrema", d: "Allungamento superiore al 400%: segue le fessurazioni e i movimenti strutturali senza rompersi." },
        { t: "Applicazione rapida", d: "Polimerizza in pochi secondi, riducendo drasticamente i tempi di cantiere." },
        { t: "Resistenza chimica e UV", d: "Inattaccabile da agenti atmosferici, sali e sostanze chimiche aggressive." },
        { t: "Aderenza totale", d: "Aderisce a cemento, metallo, legno e vecchie guaine, senza sollevamenti." },
        { t: "Durabilità superiore", d: "Vita utile molto più lunga rispetto alle impermeabilizzazioni tradizionali." },
      ]}
      applications={[
        "Coperture e tetti piani",
        "Terrazzi e balconi",
        "Vasche e piscine",
        "Fondazioni e muri controterra",
        "Canali di gronda e converse",
        "Parcheggi, rampe e autorimesse",
        "Serbatoi e cisterne",
        "Bacini di contenimento",
        "Impianti di depurazione",
        "Docce e bagni (sottopavimento)",
        "Giardini pensili e tetti verdi",
        "Fioriere e vasche interrate",
        "Coperture metalliche e lamiere grecate",
        "Fosse biologiche e pozzetti",
        "Ponti, viadotti e opere infrastrutturali",
        "Gallerie, tunnel e locali interrati",
      ]}
      faqs={[
        { q: "Quanto dura un'impermeabilizzazione in poliurea?", a: "La poliurea ha una vita utile nettamente superiore alle guaine bituminose tradizionali. Offriamo una garanzia fino a 10 anni, ma la durata effettiva del rivestimento è molto più lunga grazie alla sua resistenza a UV, agenti chimici e sbalzi termici." },
        { q: "Si può applicare sopra una vecchia guaina o pavimentazione?", a: "Sì. La poliurea aderisce a cemento, metallo, legno e a molte vecchie impermeabilizzazioni, previa idonea preparazione e pulizia del supporto. Questo consente spesso di evitare demolizioni onerose." },
        { q: "In quanto tempo la superficie torna calpestabile?", a: "La membrana polimerizza in pochi secondi ed è generalmente calpestabile entro circa un'ora, riducendo drasticamente i tempi di fermo del cantiere." },
        { q: "Dove può essere utilizzata la poliurea?", a: "Su coperture e tetti piani, terrazzi, balconi, vasche, piscine, fondazioni, canali di gronda, parcheggi, serbatoi e molte altre superfici che richiedono un'impermeabilizzazione continua e senza giunti." },
        { q: "Perché è meglio di una guaina tradizionale?", a: "Perché è una membrana continua e monolitica, priva di giunti, che sono il punto debole dove l'acqua tipicamente s'infiltra. Inoltre ha un'elasticità superiore al 400%, quindi segue i movimenti della struttura senza rompersi." },
      ]}
    />
  );
}
